import React, { useState } from 'react';
//import NewProduct from './newProduct';
import CategoriasHome from './categoriasHome';
import AboutUs from '../AboutUs';
import Testimonials from '../aboutUs/testimonials';
import Contact from '../aboutUs/contact';


function BodyUni() {
    const [selectedCategoryId, setSelectedCategoryId] = useState(null); // Estado para el idCategoria

    return (
        <div>
            <div className='py-4'>
                <CategoriasHome setSelectedCategoryId={setSelectedCategoryId} />
            </div>
            <AboutUs />
            <Testimonials />
            <Contact />
        </div>
    );
}

export default BodyUni;
